import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { Box, Button, IconButton, Stack } from "@mui/material";
import type { FC, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { AssetCount } from "../asset-count";
import { AssetGrid } from "../asset-grid";
import type { ContentLibraryState } from "../reducer/reducer";
import type { Asset } from "../server/digital-asset-service";

type ContentLibraryAssetsProps = {
  filteredData: Asset[];
  state: ContentLibraryState;
  slots: {
    breadcrumb: ReactElement;
    filter: ReactElement;
    contentTypeChips: ReactElement;
    searchField: ReactElement;
    tagChips: ReactElement;
  };
  designer?: string | null;
  onSelectAsset: (asset: Asset) => void;
  onCreateFolder: () => void;
};

export const ContentLibraryAssets: FC<ContentLibraryAssetsProps> = ({
  filteredData,
  state,
  slots,
  designer,
  onSelectAsset,
  onCreateFolder,
}) => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        {slots.breadcrumb}
        <Stack direction="row" alignItems="center" gap={1}>
          <Button variant="text" color="primary" data-analytics-id="content-library-move-folder">
            {t("Move folder")}
          </Button>
          <Button
            variant="text"
            color="primary"
            data-analytics-id="content-library-create-sub-folder"
            onClick={onCreateFolder}
          >
            {t("Create sub-folder")}
          </Button>
          <IconButton data-analytics-id="content-library-delete-folder">
            <DeleteOutline color="error" sx={{ fontSize: 20 }} />
          </IconButton>
        </Stack>
      </Box>
      <Stack direction="row" justifyContent="space-between" pb={2}>
        <Box flexGrow={1} mr={2}>
          {slots.searchField}
        </Box>
        {slots.filter}
      </Stack>
      <Stack direction="row" justifyContent="space-between">
        <AssetCount assets={filteredData} searchText={state.searchText} />
      </Stack>
      <Stack gap={1} sx={{ mb: 2 }}>
        {slots.contentTypeChips}
        {slots.tagChips}
      </Stack>
      <AssetGrid assets={filteredData} onClick={onSelectAsset} designer={designer} />
    </Stack>
  );
};
